import "react-toastify/dist/ReactToastify.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import { FlowyGlobalProvider } from "flowy-3-core";
import { FlowyNotificationsProvider } from "./components/providers";
import {
  PlatformInterface,
} from "./client";
import config from "./config";
import { antdTheme } from "./client/gizmoConfigurations";
import locale from 'antd/locale/es_ES';
import ApprovedSearch from "./ApprovedSearch";
import './index.css'

function App() {
  return (
    <div className="notranslate">
      <span>v0.0.22-g</span>
      <FlowyGlobalProvider
        apiUrl={config.apiUrl}
        loadingComponent={<div>Loading...</div>}
        platformInterface={PlatformInterface}
      >
        <ConfigProvider
          theme={antdTheme}
          locale={locale}
        >
          <FlowyNotificationsProvider>
            <Router>
              <Routes>
                <Route path="/*" element={<ApprovedSearch />}/>
              </Routes>
            </Router>
          </FlowyNotificationsProvider>
        </ConfigProvider>
      </FlowyGlobalProvider>
    </div>
  );
}

export default App;
